import { MemberLogItem } from './member.log.item';
import { AdminLogItem } from './admin.log.item';
import { Note } from './note';
import { TicketItem } from './ticket.item';
import { EmailLogItemBasic } from './email.log.item.basics';
import { FileUploadItem } from './file.upload.item';

export enum ActivityTypes {
    Note = 0,
    MemberLogItem = 1,
    AdminLogItem = 2,
    Email = 3,
    Ticket = 4,
    FileUpload = 5,
    MemberSection = 99
}

export class ActivityItem<T> {

    ActivityType: ActivityTypes;
    DateTimeCreated: Date;
    Data: T;



    public static NoteItem(Item: ActivityItem<Note>): Note {
        return Item.Data;
    }

    public static MemberLogItem(Item: ActivityItem<MemberLogItem>): MemberLogItem {
        return Item.Data;
    }

    public static AdminLogItem(Item: ActivityItem<AdminLogItem>): AdminLogItem {
        return Item.Data;
    }

    public static EmailItem(Item: ActivityItem<EmailLogItemBasic>): EmailLogItemBasic {
        return Item.Data;
    }

    public static TicketItem(Item: ActivityItem<TicketItem>): TicketItem {
        return Item.Data;
    }

    public static FileUploadItem(Item: ActivityItem<FileUploadItem>): FileUploadItem {
        return Item.Data;
    }

    public static MemberSectionItem(Item: ActivityItem<MemberSectionItem>): MemberSectionItem {
        return Item.Data;
    }

    static FixDate(item: ActivityItem<any>) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}


export class ActivityItemArray extends Array<ActivityItem<any>> {

    constructor(...items: ActivityItem<any>[]) {
        super(...items);
        Object.setPrototypeOf(this, ActivityItemArray.prototype);
    }

    static FixDates(items: ActivityItemArray) {
        items.forEach(x => ActivityItem.FixDate(x));
    }
}


export class MemberSectionItem {
    MemberName : string;
    MemberID : number;
}